import { SvgIcon, SvgIconProps } from "@mui/material";
export const Filter = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21 1H1L9 10.46V17L13 19V10.46L21 1Z"
          stroke="#606A78"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};
